import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Navbar from 'reactstrap/lib/Navbar';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { AnimatedCollapse } from 'client/site-modules/shared/utils/collapse-utils';
import { NavigationLinks } from './navigation-links';
import { InsiderSection } from './insider-section';

// Navigation for xs and sm screens

const Navigations = memo(({ pathname, isAppraisalLinkExcluded, withAiLink, use2027Theme }) => (
  <Navbar
    className="global-navigation-mobile-dropdown-menu px-0_25 pt-0 pb-1"
    data-tracking-parent="nav-drawer"
    aria-label="Main Navigation"
  >
    <NavigationLinks
      className="d-flex flex-column"
      renderHomeLink
      displayFullLinksText
      pathname={pathname}
      renderAppraisalLink={!isAppraisalLinkExcluded}
      withAiLink={withAiLink}
      isMobile
      use2027Theme={use2027Theme}
    />
    <hr className="w-100 color-gray-lighter" />
    <FeatureFlag name="insider">
      <InsiderSection className="d-flex flex-column" use2027Theme={use2027Theme} />
    </FeatureFlag>
  </Navbar>
));

export function GlobalNavigationMobile({
  pathname = '',
  isOpen = false,
  preventCloseClassName = '',
  isAppraisalLinkExcluded = false,
  withAiLink = false,
  use2027Theme = false,
  children,
}) {
  return (
    <Fragment>
      <div
        className={classNames('global-navigation-mobile d-flex align-items-center px-0_5', {
          'is-open': isOpen,
        })}
      >
        {children}
      </div>
      <div className="pos-r">
        <AnimatedCollapse
          isOpen={isOpen}
          className={classNames(preventCloseClassName, 'pos-a top-0 left-0 right-0', {
            'bg-primary': !use2027Theme,
            'rounded-8 mx-1': use2027Theme,
          })}
          style={
            use2027Theme
              ? {
                  background: 'rgba(255, 247, 240, .98)',
                  boxShadow: '0 20px 50px rgba(15, 26, 42, .18)',
                  backdropFilter: 'blur(18px)',
                }
              : null
          }
        >
          <hr className="w-100 color-gray-lighter mt-0" />
          <Navigations
            pathname={pathname}
            isAppraisalLinkExcluded={isAppraisalLinkExcluded}
            withAiLink={withAiLink}
            use2027Theme={use2027Theme}
          />
        </AnimatedCollapse>
      </div>
    </Fragment>
  );
}

GlobalNavigationMobile.propTypes = {
  pathname: PropTypes.string,
  isOpen: PropTypes.bool,
  preventCloseClassName: PropTypes.string,
  isAppraisalLinkExcluded: PropTypes.bool,
  withAiLink: PropTypes.bool,
  children: PropTypes.node.isRequired,
  use2027Theme: PropTypes.bool,
};
